import { mapState, mapGetters, mapActions } from 'vuex'

export const dashboardComputed = {
  ...mapState('dashboard', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('dashboard', [
    'getLastMeasure',
    'getListDelivery',
    'getMemberChart',
    'getDeviceChart',
    'getNotificationChart',
  ]),
}

export const dashboardMethods = mapActions('dashboard', [
  'fetchingLastMeasure',
  'resetLastMeasure',
  'fetchingMemberChart',
  'resetMemberChart',
  'fetchingDeviceChart',
  'resetDeviceChart',
  'fetchingNotificationChart',
  'fetchingListDelivery',
])
